import { render, staticRenderFns } from "./InputTables.vue?vue&type=template&id=3af169f9&"
import script from "./InputTables.vue?vue&type=script&lang=js&"
export * from "./InputTables.vue?vue&type=script&lang=js&"
import style0 from "./InputTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports